import types from "../types";
import { copy, Notification, url_encode } from "../../utils";
import backend from "../../api";
import { global_actions, auth_actions } from "../";

export const create_order = (order_data, history) => (dispatch, getState) => {
  const { user: user_state } = getState().auth;
  let state = copy(getState().order.orders);

  const status = new Notification();
  if (user_state) {
    dispatch(global_actions.loading(true));
    backend
      .post("/order", order_data, {
        params: {
          populate: url_encode([
            { path: "items", populate: [{ path: "product" }] },
            {
              path: "customer",
              populate: [{ path: "user", select: "-password" }],
            },
          ]),
        },
      })
      .then(({ data }) => {
        state = state ? state.concat([data.data]) : [data.data];

        status.set_toast("success", data.message);
        dispatch({
          type: types.ORDER,
          payload: { orders: state },
        });
        dispatch(auth_actions.login_by_token());
        dispatch(global_actions.loading(false));
        status.show_toast();
        // history.replace("/order-success", { ...data.data });
        // history.replace("/dashboard/customer/order");
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
        status.show_toast();
        dispatch(global_actions.loading(false));
      });
  } else {
    status.set_toast("warn", "Please login to place an order");
    status.show_toast();
  }
};

// Fetch orders action
export const fetch_orders = (query) => (dispatch, getState) => {
  const status = new Notification();
  dispatch(global_actions.loading(true));
  backend
    .get("/order", {
      params: {
        ...query,
        populate: url_encode([
          {
            path: "items",
            populate: [
              {
                path: "product",
                populate: [{ path: "merchant_user" }],
              },
            ],
          },
          {
            path: "customer",
            populate: [{ path: "user", select: "-password" }],
          },
        ]),
      },
    })
    .then(({ data }) => {
      if (data.data.length === 0) {
        status.set_toast("info", "There are no orders available");
      }
      dispatch({
        type: types.ORDER,
        payload: { orders: data.data, totalPages: data.totalPages },
      });
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
    })
    .finally(() => {
      dispatch(global_actions.loading(false));
    });
};

// Fetch different order statuses actions
export const fetch_checked_out_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "checked_out", ...query }));
};

export const fetch_cancel_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "cancel", ...query }));
};

export const fetch_declined_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "declined", ...query }));
};

export const fetch_in_progress_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "in_progress", ...query }));
};

export const fetch_delivered_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "delivered", ...query }));
};

export const fetch_return_orders = (query = {}) => (dispatch) => {
  if (query.metric) delete query.metric;
  dispatch(fetch_orders({ metric: "return", ...query }));
};

// Update order status action
export const update_order_status = (data) => (dispatch, getState) => {
  let state = copy(getState().order.orders) || [];
  const status = new Notification();
  dispatch(global_actions.loading(true));

  return backend
    .put(`/order/${data.order_id}/status`, data, {
      params: {
        populate: url_encode([
          {
            path: "items",
            populate: [
              {
                path: "product",
              },
            ],
          },
          {
            path: "customer",
            populate: [
              {
                path: "user",
                select: "-password",
              },
            ],
          },
        ]),
      },
    })
    .then(({ data }) => {
      state = state.filter((i) => i._id !== data.data._id).concat([data.data]);
      status.set_toast("info", data.message);
      dispatch({
        type: types.ORDER,
        payload: { orders: state },
      });
      dispatch(global_actions.loading(false));
      status.show_toast();
    })
    .catch((error) => {
      status.set_toast(
        "error",
        error.response ? error.response.data.message : error.message
      );
      status.show_toast();
      dispatch(global_actions.loading(false));
    });
};

export default {
  create_order,
  fetch_orders,
  fetch_checked_out_orders,
  fetch_cancel_orders,
  fetch_declined_orders,
  fetch_in_progress_orders,
  fetch_delivered_orders,
  fetch_return_orders,
  update_order_status,
};
